import type {CommunityDoubtReason} from '../../../core/entities/community/schema';

export const isRequiredDoubtReasonDetail = ({
  selectedReasonId,
  reasonList,
}: {
  selectedReasonId: number;
  reasonList: CommunityDoubtReason[];
}) => {
  if (selectedReasonId === 0) {
    return false;
  }

  const selectedReason = reasonList.find(
    (reason) => reason.id === selectedReasonId,
  );
  if (!selectedReason) {
    return false;
  }

  return selectedReason.minDetail > 0;
};
